export default __webpack_public_path__ + "static/media/475.c6fa3879.png";